module.exports = __webpack_public_path__ + "media/images/favicon/primary/apple-icon-114x114-d2ae8c1716b0774d674a5f39091ac101.png";